module.exports = __webpack_public_path__ + "static/octavateSite-77e730c345954392385e7faf27b0fffb.jpeg";